import { css } from '@styled-system/css';
import { type FC, useEffect } from 'react';

import { Logo } from './Logo';

interface CloseButtonProps {
  onClick: () => void;
  className?: string;
}

export const CloseButton: FC<CloseButtonProps> = ({ onClick, className }) => {
  // Gestion de la touche Escape
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClick();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClick]);

  const closeButtonStyles = css({
    w: '2rem', // 32px
    h: '2rem', // 32px
    bg: 'transparent',
    border: 'none',
    borderRadius: '0.375rem', // 6px
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.2s ease',
    _hover: {
      bg: 'base.segBg', // #16171b
    },
    outline: 'none',
    _focus: {
      outline: 'none',
    },
  });

  return (
    <button className={`${closeButtonStyles} ${className || ''}`} onClick={onClick}>
      <Logo variant="close" color="font.secondary" />
    </button>
  );
};
